import { Controller } from "@hotwired/stimulus"

// Mobile hamburger menu — toggles the dropdown panel under the nav bar.
export default class extends Controller {
  static targets = ["toggle"]

  toggle() {
    const open = this.element.classList.toggle("is-open")
    this.toggleTarget.setAttribute("aria-expanded", open)
  }

  close() {
    this.element.classList.remove("is-open")
    this.toggleTarget.setAttribute("aria-expanded", false)
  }
}
